
import info from "@randajan/simple-app/info";

export const apiRaws = "/odata/raws";
export const apiVals = "/odata/vals";